import { render, staticRenderFns } from "./DayZ.vue?vue&type=template&id=054fa858&"
import script from "./DayZ.vue?vue&type=script&lang=js&"
export * from "./DayZ.vue?vue&type=script&lang=js&"
import style0 from "./DayZ.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports